// extracted by mini-css-extract-plugin
export default {"appBackground":"AppBackground_appBackground__uTEDW"};